import '../dashboard/assets/scss/super_admin/index.scss';
